// extracted by mini-css-extract-plugin
module.exports = {"toggle":"menu-toggle_toggle__pJuui","active":"menu-toggle_active__aVpaZ"};